import React, { cloneElement, useState } from "react";
import { Typography, IconButton, Popover, List, ListItem, ListItemButton, ListItemText, Dialog, DialogContent, DialogTitle, Box } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faEllipsis } from "@fortawesome/free-solid-svg-icons";
import { shallow } from "zustand/shallow";
import { createPortal } from "react-dom";
import { Close as CloseIcon } from "@mui/icons-material";
import useDashboardStore from "@/state/dashboard";
import html2canvas from "html2canvas";
import "./WidgetContainer.css";
import "../Widgets/Widgets.css";

const WidgetContainer = (props, ref) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const { style, className, onMouseDown, onMouseUp, onTouchEnd, dashboardIndex, widgetIndex, childrenWidgets, controlButtons = [] } = props;
  const { dashboardState, selectWidgetChild } = useDashboardStore(
    (state) => ({
      dashboardState: state.dashboardState,
      selectWidgetChild: state.selectWidgetChild,
    }),
    shallow
  );
  const selectedChildrenIndex = dashboardState[dashboardIndex].widgets[widgetIndex].selectedChildren;
  const currentTitle = childrenWidgets[selectedChildrenIndex]?.title;

  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  const exportPng = () => {
    if (!ref.current) return;
    html2canvas(ref.current, { useCORS: true })
      .then((canvas) => {
        const link = document.createElement("a");
        link.download = `${currentTitle}.png`;
        link.href = canvas.toDataURL("image/png");
        link.click();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div
      className={`${className} widget-container`}
      style={{ ...style }}
      // ref={ref}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      onTouchEnd={onTouchEnd}
    >
      <Dialog
        fullWidth
        maxWidth={false}
        className="widget-dialog"
        keepMounted={false}
        open={dialogOpen}
        onClose={() => {
          setDialogOpen(false);
        }}
      >
        <Typography variant="widgetTitle" sx={{ textAlign: "center", mt: 2 }}>
          {currentTitle}
        </Typography>
        <IconButton
          onClick={() => {
            setDialogOpen(false);
          }}
          sx={{ position: "absolute", right: 10, top: 10 }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent sx={{ height: "85dvh" }}>
          <Box sx={{ borderRadius: 1, height: 1, overflow: "hidden" }}>
            {cloneElement(childrenWidgets[selectedChildrenIndex].widget, { isFullScreen: true })}
          </Box>
        </DialogContent>
      </Dialog>
      {createPortal(
        <div className="widget-download" ref={ref}>
          <div className="widget-content-title-download">{currentTitle}</div>
          <div className="widget-content-download">{childrenWidgets[selectedChildrenIndex].widget}</div>
        </div>,
        document.body
      )}
      <div
        className="widget-title"
        style={{ width: childrenWidgets.length === 1 ? "100%" : undefined }}
        onClick={(e) => {
          if (!["BUTTON", "path", "svg"].includes(e.target.tagName)) setDialogOpen(true);
        }}
      >
        <div>
          <Typography variant="widgetTitle">{currentTitle}</Typography>
        </div>
        {controlButtons.map((button) => (
          <div className="widget-buttons" style={{ width: "300px" }}>
            {button}
          </div>
        ))}
        {childrenWidgets.length > 1 && (
          <div className="widget-buttons">
            <IconButton
              onClick={(event) => {
                setAnchorEl(event.currentTarget);
              }}
            >
              <FontAwesomeIcon icon={faEllipsis} style={{ fontSize: 22 }} />
            </IconButton>
          </div>
        )}
        <IconButton className="widget-buttons" onClick={exportPng}>
          <FontAwesomeIcon icon={faDownload} fontSize={19} />
        </IconButton>
      </div>
      <div className="widget-content">{childrenWidgets[selectedChildrenIndex].widget}</div>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClosePopover}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <div className="widget-children-selector-container">
          <List>
            {childrenWidgets.map((child, index) => {
              return (
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => {
                      selectWidgetChild(dashboardIndex, widgetIndex, index);
                      setAnchorEl(null);
                    }}
                  >
                    <ListItemText primary={child.title} />
                  </ListItemButton>
                </ListItem>
              );
            })}
          </List>
        </div>
      </Popover>
    </div>
  );
};

export default React.forwardRef(WidgetContainer);
